import { SHORTCUT_PAGE_INFO_FIELDS } from '@@partner:graphql/shortcuts'
import { VehicleInfo } from '@@partner:types:app'
import { CRUD_Variables, PageInfo } from '@@partner:types:graphql'
import { gql, useQuery } from '@apollo/client'



export type AllVehiclesQuery = {
  allVehicles: {
    edges: VehicleInfo[]
    pageInfo: PageInfo
  }
}

export const GQL_QUERY_ALL_VEHICLES = gql`
  query allVehicles(
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allVehicles (
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
      edges {
        id
        type {
          id
          name
          code
          description
        }
        vehicle_type_id
        license_plate
        vin
        brand
        model
        year
        color
        capacity_kg
        capacity_m3
        temp_min_c
        temp_max_c
        range_km
        average_speed
        is_active
        comment
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export const useFetchAllVehicles = (variables: CRUD_Variables) => {
  const { data, loading, error } = useQuery<AllVehiclesQuery, CRUD_Variables>(GQL_QUERY_ALL_VEHICLES, {
    variables
  })

  const vehicles = data?.allVehicles.edges || []

  return { data, loading, error, vehicles }
}